<template>
    <button class="uk-button uk-button-primary" v-html="text"></button>
</template>

<script>
  export default {
    name: 'primary-button',
    props: {
      text: {
        type: String,
        default: 'Submit'
      }
    }
  };
</script>

<style scoped>

</style>
